import React, { useState, useEffect } from 'react'
// ** React Imports
import { Outlet } from "react-router-dom"
import { Clipboard, BarChart, Search } from "react-feather"
import { useSelector } from "react-redux"

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "../@core/layouts/VerticalLayout"
import { isUserLoggedIn } from "../utility/Utils"
import themeConfig from '../configs/themeConfig'
// ** Menu Items Array
// import navigation from "@src/navigation/vertical"
// ** Menu Items Array
// import navigation from "@src/navigation/vertical"

const VerticalLayout = (props) => {
  const [menusData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  useEffect(() => {

    if (isUserLoggedIn()) {
      const userData = (JSON.parse(localStorage.getItem('userData')))
      const userRoles = userData?.userRoles
      // let companyList = false
      // let userList = false
      // let vesselList = false
      // let roleManagment = false
      // let companyEditable = false
      // let userEditable = false
      // let vesselEditable = false
      // let roleManagmentEditable = true
      // if (userRoles) {
      //   const findSARole = userRoles?.find(find => find.roleId === 1)
      //   if (findSARole) {
      //     companyList = true
      //     userList = true
      //     vesselList = true
      //     roleManagment = true

      //     companyEditable = true
      //     userEditable = true
      //     vesselEditable = true
      //     roleManagmentEditable = true
      //   } else {
      //     const findUserRole = userRoles.find(find => find.roleId === 2 || find.roleId === 3)
      //     if (findUserRole) {
      //       userList = true
      //     }
      //     if (userRoles.find(find => find.roleId === 2)) {
      //       userEditable = false
      //     } else if (userRoles.find(find => find.roleId === 3)) {
      //       userEditable = true
      //     }

      //     const findCompanyRole = userRoles.find(find => find.roleId === 4 || find.roleId === 5)
      //     if (findCompanyRole) {
      //       companyList = true
      //     }
      //     if (userRoles.find(find => find.roleId === 4)) {
      //       companyEditable = false
      //     } else if (userRoles.find(find => find.roleId === 5)) {
      //       companyEditable = true
      //     }

      //     const findVesselRole = userRoles.find(find => find.roleId === 6 || find.roleId === 7)
      //     if (findVesselRole) {
      //       vesselList = true
      //     }
      //     if (userRoles.find(find => find.roleId === 6)) {
      //       vesselEditable = false
      //     } else if (userRoles.find(find => find.roleId === 7)) {
      //       vesselEditable = true
      //     }

      //   }
      // }
      const allMenuData = [
        // {
        //   id: "1",
        //   title: "Home",
        //   icon: '',
        //   img: themeConfig.navicons.home2,
        //   img1: themeConfig.navicons.home1,
        //   color1: '#fff',
        //   color2: '#313131',
        //   navLink: "/dashboard",
        //   show: false,
        //   menuId: 1,
        //   editable: true
        // },
        {
          id: "companieslist",
          title: "Companies List",
          icon: '',
          img: themeConfig.navicons.home1,
          img1: themeConfig.navicons.home2,
          color1: '#fff',
          color2: '#313131',
          navLink: "/companieslist",
          show: true,
          menuId: 2,
          //  editable: companyEditable,
          childProperties: "company"
        },
        {
          id: "usersList",
          title: "Users List",
          icon: '',
          img: themeConfig.navicons.corporate1,
          img1: themeConfig.navicons.corporate2,
          color1: '#fff',
          color2: '#313131',
          navLink: "/usersList",
          show: true,
          menuId: 3,
          //   editable: userEditable,
          childProperties: "user"
        },
        {
          id: "veselsList",
          title: "Vesels List",
          icon: '',
          img: themeConfig.navicons.maritime1,
          img1: themeConfig.navicons.maritime2,
          color1: '#fff',
          color2: '#313131',
          navLink: "/veselsList",
          show: false,
          menuId: 4,
          editable: true,
          childProperties: "vesels"
        },
        {
          id: "role-management",
          title: "Role Management",
          icon: '',
          img: themeConfig.navicons.contactManagement1,
          img1: themeConfig.navicons.contactManagement2,
          color1: '#fff',
          color2: '#313131',
          navLink: "/role-management",
          show: userRoles?.find(find => (find.roleId === 1 || find.roleId === 3)),
          menuId: 5,
          editable: true
          // childProperties: "role"
        }

      ]
      setMenuData(allMenuData)
      localStorage.setItem('allMenuData', JSON.stringify(allMenuData))
    }
  }, [isUserLoggedIn()])

  return (
    <Layout menuData={menusData} {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout